import React, {useContext, useEffect, useState} from 'react';
import {useHistory, useLocation} from "react-router-dom";
import { useParams } from 'react-router';
import TermSheetDetails from "./components/term-sheet-details/term-sheet-details";
import Loading from "../../../../components/loading/loading";
import ListingService from "../../../../services/listing-service";
import TermSheetSecurities from "./components/term-sheet-securities/term-sheet-securities";
import TermSheetParticipants from "./components/term-sheet-participants/term-sheet-participants";
import RequiredDocuments from "./components/required-documents/required-documents";
import {IdentityContext} from "../../../../context/identity-context";

const ListingDetails = () => {
  //Retrieve security id from params
  const { applicationId }  = useParams();
  const { user } = useContext(IdentityContext);
  const username = user.username;

  //Set spinner state
  const [loading, setLoading] = useState(true);
  const [termSheet, setTermSheet] = useState({})
  const [requiredDocuments, setRequiredDocuments] = useState([])
  const listingService = new ListingService();
  const history = useHistory();
  const query = new URLSearchParams(useLocation().search);
  const institutionCode = query.get('ic');

  useEffect(()=> {
    const retrieveTermSheetDetails = async () => {
      try {
        const result = await listingService.retrieveTermSheetDetails(institutionCode, applicationId);
        setTermSheet(result);
        const documentList = await listingService.retrieveRequiredDocuments(institutionCode, applicationId)
        setRequiredDocuments(documentList);
      } catch(error){
        if (error.response.status === 404){
          history.push(`/resource-not-found`);
        }else {
          history.push(`/internal-server-error`);
        }
      } finally {
        setLoading(false);
      }
    }
    retrieveTermSheetDetails();
    // eslint-disable-next-line
  }, []);

  const computePercentage = () => {
    const tabLength = 8;
    const tabSubmitted = termSheet.applicationStatus === '0' ? parseInt(termSheet.activeTabIndex) : 8;
    // const docLength = requiredDocuments.length;
    // const docSubmitted = requiredDocuments.filter(d => d.documentStatus === '1').length;
    //console.log(tabSubmitted);
    return Math.ceil(tabSubmitted/tabLength*100);
  }

  const editAllowed = () => {
    // return termSheet.sortKey.split(':')[0] === username
    return true
  }

  return loading ? <Loading /> : (
    <>
      <TermSheetDetails context={{computePercentage, termSheet, setTermSheet, editAllowed}}/>
      <TermSheetSecurities context={{termSheet, setTermSheet, editAllowed, institutionCode}} admin={false}/>
      <TermSheetParticipants context={{termSheet, setTermSheet, editAllowed}} admin={false} />
      <RequiredDocuments context={{applicationId, requiredDocuments, setRequiredDocuments, institutionCode, editAllowed}}/>
    </>
  )
}

export default ListingDetails;
